import React, { useMemo } from 'react';

import { IconButton, CloseIcon } from '@gogame/components';
import { useScreenDispatch, useScreenState } from '@gogame/screens';

import { REMOVE_CHART } from 'scenes/Trackers/Tracker/reducers';

import { useChartIndex } from '../hooks';

export const RemoveChartAction = () => {
  const dispatch = useScreenDispatch();
  const chartIndex = useChartIndex();
  const screenState = useScreenState();

  const canRemove = useMemo(() => {
    return screenState.charts.length > 1;
  }, [screenState.charts.length]);

  const onClose = () => {
    dispatch({
      type: REMOVE_CHART,
      payload: {
        index: chartIndex,
      },
    });
  };

  if (!canRemove) {
    return null;
  }

  return (
    <IconButton
      tooltip={'Remove chart'}
      icon={<CloseIcon />}
      onClick={onClose}
    />
  );
};
